import React from 'react';
import { Trans } from 'react-i18next';
import { t } from 'i18next';
import { useApi } from 'lib/ApiContext';

export default function StoreDetails({ name }) {
  const { settings } = useApi();
  const store = settings.stores[name];
  if (!store) return null;
  return (
    <div className="my-2">
      <div className="mt-1">
        <Trans
          i18nKey="return.address"
          values={{
            address: store.address
          }}
          components={{ strong: <strong /> }}
        />
      </div>
      <div className="flex">
        <span>{t('return.opening_times')}</span>
        <div className="ml-2">
          {Object.keys(store.opening_times).map((k) => (
            <div key={k} className="text-gray-600">
              {t(`day.${k}`)}: {store.opening_times[k].join(',')}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
